import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { KANBAN_PERMISSIONS } from 'dashboard/constants/permissions.js';

const meta = {
  featureFlag: FEATURE_FLAGS.KANBAN,
  permissions: ['administrator', 'agent', KANBAN_PERMISSIONS],
};

const kanbanRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_boards_index',
      meta,
      component: () =>
        import('dashboard/components-next/Kanban/Pages/BoardListPage.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/kanban/:boardId'),
      name: 'kanban_board_show',
      meta,
      component: () =>
        import('dashboard/components-next/Kanban/Pages/BoardPage.vue'),
    },
  ],
};

export default kanbanRoutes;
